import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
/**
 * @copyright 2016 commenthol
 * @license MIT
 */

import { julian } from 'astronomia';
import CalendarChinese from './Chinese.js';

// Start of Korean Calendar in 2333 BCE (단군기원 http://ko.wikipedia.org/wiki/단기)
var epochY = -2333;
var epoch = new julian.CalendarGregorian(epochY, 1, 27).toJDE();

/**
 * change of timezone shifts during the last century
 * @see https://en.wikipedia.org/wiki/Time_in_South_Korea
 */
var UTC_DATES = [{
  date: new Date('1961-10-09T15:00:00.000Z'),
  // 1961-10-10T00:00:00+0900
  shift: 9 / 24
},
// +9:00:00h (135° East)
{
  date: new Date('1954-03-20T15:30:00.000Z'),
  // 1954-03-21T00:00:00+0830
  shift: 8.5 / 24
}, {
  date: new Date('1911-12-31T15:00:00.000Z'),
  // 1912-01-01T00:00:00+0900
  shift: 9 / 24
}, {
  date: new Date('1908-03-31T15:30:00.000Z'),
  // 1908-04-01T00:00:00+0830
  shift: 8.5 / 24
}];
var CalendarKorean = /*#__PURE__*/function (_CalendarChinese) {
  _inherits(CalendarKorean, _CalendarChinese);
  var _super = _createSuper(CalendarKorean);
  function CalendarKorean(cycle, year, month, leap, day) {
    var _this;
    _classCallCheck(this, CalendarKorean);
    _this = _super.call(this, cycle, year, month, leap, day);
    _this._epochY = epochY;
    _this._epoch = epoch;
    return _this;
  }

  /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */
  _createClass(CalendarKorean, [{
    key: "timeshiftUTC",
    value: function timeshiftUTC(gcal) {
      var date = gcal.toDate();
      for (var i in UTC_DATES) {
        if (date >= UTC_DATES[i].date) {
          return UTC_DATES[i].shift;
        }
      }
      return 3809 / 450 / 24; // +8:27:52h Seoul City Hall 126°58'E
    }
  }]);
  return CalendarKorean;
}(CalendarChinese);
export { CalendarKorean as default };